import { Vendor } from "./index";

export class AccountCategoryVendor {
    id: number;
    financialCommunityId: number;
    vendorId: number;
    acctCategoryId: number;
    isPriorityVendor: boolean;
    vendor: Vendor;
}
